<!--
 * @Author: Jason
 * @Date: 2019-10-16 10:48:18
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-11-18 10:47:15
 * @Descripttion:
 -->
<template>
  <div>
    <v-head backUrl="/service" :isShowBack="$route.meta.isShowIcon">支付</v-head>
    <div class="mt flex-btwn-aic service-price">
      <div>
        普通洗车
        <span>（七座以下含七座非营运车辆）</span>
      </div>
      <div class="service-price-num">购买数量X1</div>
    </div>
    <div class="service-order-info">
      <div class="service-order-info-title">支付金额</div>
      <div class="service-now-price">
        ￥
        <span>1.00</span>
      </div>
      <div class="service-old-price">原价￥40</div>
    </div>
    <div class="service-pay-style">
      <div class="service-name">支付方式</div>
      <div class="flex-btwn-aic service-pay-style-info" v-if="isWx">
        <div class="flex-aic">
          <img class="service-pay-bank-logo" src="../../assets/imgs/pic_wx.png" alt />
          <div class="service-pay-bank">微信支付</div>
        </div>
        <div class="service-pay-check">
          <img src="../../assets/imgs/checked.png" alt />
        </div>
      </div>
      <div class="flex-btwn-aic service-pay-style-info" v-else>
        <div class="flex-aic">
          <img class="service-pay-bank-logo" src="../../assets/imgs/pic_nh.png" alt />
          <div class="service-pay-bank">农行支付</div>
        </div>
        <div class="service-pay-check">
          <img src="../../assets/imgs/checked.png" alt />
        </div>
      </div>
    </div>
    <div class="service-pay-tip">* 抢购成功后请尽快到盛大网点使用，有效期30天，过期失效，无法使用。</div>
    <div class="footer-btn" @click="toPay()">立即支付</div>
  </div>
</template>
<script>
import vHead from "@/components/vHead.vue";
import { GetWxPay, GetNhPay } from "@/api/order.js";
import { ls, GetQueryString ,ISWX} from "@/assets/js/utils.js";
import { MessageBox } from "mint-ui";
export default {
  components: {
    vHead
  },

  data() {
    return {

    };
  },
  computed:{
    isWx(){
      return ISWX()
    }
  },
  methods: {
    toBack() {
      console.log("返回按钮");
    },
    checkPayStyle(val) {
      let _ = this;
      _.curPayType = val;
    },
    toPay() {
      let _ = this;

      if(ls.getter('loginStatus')){
        if (_.isWx) {
          _.weixinPay();
        }else{
          _.bankPay();
        }
      }else{
        _.$router.push('/login');
      }




    },
    bankPay() {
      let _ = this
      let pars = {
        token:ls.getter("loginStatus")
      }
      GetNhPay(pars).then(res => {
        console.log("获取成功", res);
        window.location.href = res.html
      })
      .catch(err => {
        if (err && err.resultDes) {
          _.toast(err.resultDes);
        }
      });
    },
    // 微信支付
    weixinPay() {
      let _ = this;
      var prepay_id;
      var paySign;
      var appId;
      var timeStamp;
      var nonceStr;
      var packageStr;
      var signType;
      var orderId;
      pay();
      function pay() {
        let pars = {
          code: sessionStorage.wxCode,
          token: ls.getter("loginStatus"),
          type: 2
        };
        GetWxPay(pars)
          .then(res => {
            console.log("获取成功", res);
            orderId = res.orderId;
            // var pnPayStr1 = JSON.parse(res.html);
            // console.log("pnPayStr1",pnPayStr1)
            var pnPayStr1 = eval('(' + res.html + ')');
            if (pnPayStr1.code == "0000") {
            // if (pnPayStr1.resultCode == "SUCCESS") {
              var pnPayStr = JSON.parse(pnPayStr1.data.pnPayStr);
              appId = pnPayStr.appId;
              paySign = pnPayStr.paySign;
              timeStamp = pnPayStr.timeStamp;
              nonceStr = pnPayStr.nonceStr;
              packageStr = pnPayStr.packageStr;
              signType = pnPayStr.signType;
              callpay();
            } else {
              // MessageBox.alert("授权失败,重新获取授权信息").then(action => {
              //   // 回调函数
              //   _.$router.push("/home");
              // });
            }
          })
          .catch(err => {
            if (err && err.resultDes) {
              _.toast(err.resultDes);
            }
          });
      }

      function callpay() {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      }

      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: appId, //公众号名称，由商户传入
            paySign: paySign, //微信签名
            timeStamp: timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: nonceStr, //随机串
            package: packageStr, //预支付交易会话标识
            signType: signType //微信签名方式
          },
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              MessageBox.alert("支付成功！").then(action => {
                // 回调函数
                _.$router.push(`/service/result/${orderId}`);
              });
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              MessageBox.alert("支付取消,重新获取授权信息").then(action => {
                // 回调函数
                _.$router.push("/home");
              });
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              MessageBox.alert("支付失败,重新获取授权信息").then(action => {
                // 回调函数
                _.$router.push("/home");
              });
            } //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
          }
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.service-name {
  font-size: 4vw;
  font-weight: bold;
}

.service-price {
  width: 100%;
  height: 13.0667vw;
  background-color: #fff;
  font-size: 3.7333vw;
  font-weight: bold;
  padding: 0 4vw;
  span {
    font-size: 2.6667vw;
  }
  .service-price-num {
    color: #ff8585;
    font-weight: normal;
  }
}
.service-order-info {
  width: 100%;
  margin-top: 2.6667vw;
  background-color: #fff;
  padding: 4.6667vw 4vw;
  .service-order-info-title {
    font-weight: bold;
  }
  .service-now-price {
    color: #ff4c4c;
    font-weight: bold;
    text-align: center;
    margin-top: 6vw;
    span {
      font-size: 8.8vw;
    }
  }
  .service-old-price {
    color: #999999;
    text-align: center;
    margin-top: 1vw;
    text-decoration: line-through;
  }
}

.service-pay-style {
  padding: 4.6667vw 4vw;
  width: 100%;
  background-color: #fff;
  margin-top: 2.6667vw;
  .service-pay-style-info {
    font-size: 4vw;
    margin-top: 4.6667vw;
    .service-pay-check {
      width: 6vw;
      height: 6vw;
      border-radius: 50%;
      overflow: hidden;
    }
    .service-pay-bank-logo {
      width: 10vw;
      height: auto;
      margin-top: -2px;
    }
    .service-pay-bank {
      margin: 0 2vw;
    }
  }
}
.service-pay-tip {
  color: #ff6521;
  font-size: 3.2vw;
  padding: 4vw;
}
</style>


